(function(konto) {
	konto.sd = {};
} (konto = window.konto));
